import { getValueFromObject } from '../../object/getValueFromObject/getValueFromObject';
/**
 * groupBy - Creates an object composed of keys generated from the results of running each element of array thru getKey
 *
 * @template T
 * @param {Array<T>} array
 * @param {string | (o: object) => string} getGroupKey
 * @return {*}
 * @example
 * groupBy(['one', 'two', 'three'], 'length');
 * // return { '3': ['one', 'two'], '5': ['three'] }
 */
export var groupBy = function (array, getGroupKey) {
    var obj = {};
    var groupKey;
    return array.reduce(function (acc, item) {
        groupKey = getValueFromObject(item, getGroupKey);
        (acc[groupKey] || (acc[groupKey] = [])).push(item);
        return acc;
    }, obj);
};
//# sourceMappingURL=groupBy.js.map